// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605081003/js/" + chunkId + "." + {"44":"4ce728cc","225":"1ca92327","481":"85f8ca12","486":"57283262","770":"6a1acd76"}[chunkId] + ".0.7467205356222211.chunk.js";
};